<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-1">
<h1><span dir="rtl">٢</span></h1>
<p style="text-indent:17px;"><span dir="rtl">بعد حفل رأس السنة، أربعة مراهقين طائشين، عائدين إلى منازلهم بعد أن اختبروا القليل مِن عالم الناضجين، يتبخترون كالأسود، جاهزون للانقضاض على الحياة.</span></p>
<p><span dir="rtl">في المقدّمة فتًى في السابعة عشرة مِن العمر وصديقته التي تصغره بثلاث سنوات، في الخلف تالا الضاحكة شعرها يطير في الهواء وهو لا يستطيع رؤية نفسه قربها، لكنَّه يستطيع أن يرى انعكاسه في المرآة الأماميَّة.</span></p>
<p><span dir="rtl">الرؤية غير واضحة فكلُّ شيءٍ رمادي، ميرا ما زالت تضع قبعة العيد على رأسها، تيدي يحاول جهده أن يركِّز على القيادة وهو مسرِع، وتالا التي يبدو عليها السُّكر تُبعد شعرها عن وجهها، وتضع رأسها على صدر إيفان الذي يغنّي مع الراديو بحماسةٍ إحدى الأغاني الأجنبية.</span></p>
<p><span dir="rtl">- أنا كتير بحبّك.</span></p>
<p><span dir="rtl">ينظر نحوها مبتسمًا، ويتوقَّف عن الغناء، يرفع شعرها عن وجهها، وقبل أن يتمكَّن مِن الاعتراف لها بحبّه أو حتى تقبيلها تسبقه:</span></p>
<p><span dir="rtl">- بدّي إستفرِغ.</span></p>
<p><span dir="rtl">يستدرك الفتى الأمر صارخًا:</span></p>
<p><span dir="rtl">- لا لا لا مش بالسيَّارة، راسك برَّا هلّق بوقفلك، ما بكفّي سارقين سيّارة البابا؟!</span></p>
<p><span dir="rtl">تُخرٍج تالا رأسها قبل أن تتوقَّف السيَّارة، في الوقت نفسه الذي تمرُّ قربهم شاحنة مسرعة، فتخلّ توازن تيدي في القيادة، وتزيد مِن ارتباكه وخوفه على رأس شقيقته، فيعطف مقود السيَّارة إلى أقصى حدّ، يحضن إيفان تالا ويشدُّها نحوه، فتقع عليه في حين يسمع صوت ميرا في صراخٍ هستيري وهي تحذِّره مِن الاصطدام، صوتها الذي تخطَّى الخوف لسنين طويلة أبقاه مِن دون نوم.</span></p>
<p><span dir="rtl">يفتح عينيه وينظر نحو تالا النائمة مِن دون درايةٍ منها لما حدث، أو هي في حالة تكرار للحادث!؟ ألِهذا لا تستطيع الاستيقاظ؟</span></p>
<p><span dir="rtl">يقترب منها وقلبه ما زال ينبض سريعًا، كان يظنُّ أنَّ هذا الحلم لن يتكرَّر، لكن ها هو مِن جديد عاد ليوجعه.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?028eff83